/* GoGo Solar — the “Let us light up your space” enquiry form.

   THIS FORM WAS LOSING EVERY ENQUIRY.

   The ported build shipped it with no action and no handler, so it went
   nowhere. It was then wired to post to /contact with fetch(). That never
   worked either: the store has reCAPTCHA on contact forms and the token is
   attached by Shopify's script only to forms rendered by the Liquid form
   tag, so a form built in JavaScript is answered 400 "Missing CAPTCHA
   token". Worse, the handler was .catch(function(){}).then(showThanks), so
   the customer was told “Thanks — we’ve got it” every single time while
   nothing was sent and nothing was stored. There is no record of how many
   enquiries were lost that way.

   It now hands the enquiry to the real Liquid contact form rendered by
   snippets/bsl-real-forms.liquid and lets Shopify submit it. Shopify emails
   the store contact address as it always should have.

   The confirmation is shown ONLY when Shopify reports the send succeeded,
   read from data-ok on #bsl-real-contact-result. If Shopify reports an
   error, the customer sees the error and the address to email instead. No
   more thanking people for messages that were never sent. */
(function () {
  var STYLE_ID = "bsl-quote-style-v2";
  var PENDING = "bsl-quote-pending";
  var GOLD = "#F5A800";
  var INK = "#171A15";

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      ".bsl-q-msg{margin-top:1.1rem;font-family:Inter,system-ui,sans-serif;font-size:.9rem;" +
        "line-height:1.6;color:" + INK + "}",
      ".bsl-q-msg b{display:block;font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;" +
        "font-size:1.1rem;font-weight:800;margin-bottom:.35rem}",
      ".bsl-q-msg em{font-style:normal;color:" + GOLD + "}",
      ".bsl-q-err{margin-top:.8rem;font-family:Inter,system-ui,sans-serif;font-size:.82rem;" +
        "color:#B4342B}"
    ].join("");
    document.head.appendChild(s);
  }

  function field(form, names) {
    for (var i = 0; i < names.length; i++) {
      var el = form.querySelector('[name="' + names[i] + '"]');
      if (el) return el;
    }
    return null;
  }

  function pending() {
    try { return sessionStorage.getItem(PENDING); } catch (e) { return null; }
  }

  function setPending(v) {
    try {
      if (v === null) sessionStorage.removeItem(PENDING);
      else sessionStorage.setItem(PENDING, v);
    } catch (e) {}
  }

  function verdict() {
    var el = document.getElementById("bsl-real-contact-result");
    if (!el) return null;
    return { ok: el.getAttribute("data-ok") === "1", msg: el.getAttribute("data-msg") || "" };
  }

  function showError(holder, msg) {
    if (!holder) return;
    var old = holder.querySelector(".bsl-q-err");
    if (old) old.remove();
    var p = document.createElement("p");
    p.className = "bsl-q-err";
    p.textContent = msg;
    holder.appendChild(p);
  }

  function showThanks(holder, form) {
    if (!holder) return;
    if (form) form.style.display = "none";
    var old = holder.querySelector(".bsl-q-err");
    if (old) old.remove();
    if (holder.querySelector(".bsl-q-msg")) return;
    holder.insertAdjacentHTML(
      "beforeend",
      '<div class="bsl-q-msg"><b>Thanks — <em>we’ve got it.</em></b>' +
        "We read every enquiry ourselves and will come back to you within one " +
        "working day, usually sooner.</div>"
    );
  }

  function wire() {
    var sec = document.getElementById("quote");
    if (!sec) return;
    var form = sec.querySelector("form");
    if (!form || form.dataset.bslQuote) return;
    form.dataset.bslQuote = "1";
    styles();

    /* coming back from a real submission — report Shopify's actual answer */
    var v = verdict();
    if (v && pending()) {
      setPending(null);
      if (v.ok) showThanks(form.parentElement, form);
      else {
        showError(
          form.parentElement,
          v.msg ||
            "Sorry — that didn’t send. Please email info@gogosolar.co.uk and " +
            "we’ll pick it up straight away."
        );
      }
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var nameEl = field(form, ["name", "contact[name]"]);
      var mailEl = field(form, ["email", "contact[email]"]);
      var msgEl = field(form, ["message", "contact[body]"]);

      var name = nameEl ? nameEl.value.trim() : "";
      var email = mailEl ? mailEl.value.trim() : "";
      var message = msgEl ? msgEl.value.trim() : "";

      var holder = form.parentElement;
      var old = holder.querySelector(".bsl-q-err");
      if (old) old.remove();

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) || !name) {
        showError(holder, "Please add your name and a valid email address.");
        return;
      }

      var realForm = document.getElementById("bsl-real-contact-form");
      var rName = document.getElementById("bsl-real-contact-name");
      var rMail = document.getElementById("bsl-real-contact-email");
      var rBody = document.getElementById("bsl-real-contact-body");

      if (!realForm || !rName || !rMail || !rBody) {
        showError(
          holder,
          "Sorry — the enquiry form didn’t load properly, so nothing was sent. " +
          "Please email info@gogosolar.co.uk and we’ll pick it up straight away."
        );
        return;
      }

      var btn = form.querySelector('button, [type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = "Sending…"; }

      rName.value = name;
      rMail.value = email;
      rBody.value = message;
      setPending("1");

      try {
        if (typeof realForm.requestSubmit === "function") realForm.requestSubmit();
        else {
          var rb = realForm.querySelector('button[type="submit"]');
          if (rb) rb.click(); else throw new Error("no submit button");
        }
      } catch (err) {
        setPending(null);
        if (btn) { btn.disabled = false; btn.textContent = "Send"; }
        showError(
          holder,
          "Sorry — that didn’t send. Please email info@gogosolar.co.uk and " +
          "we’ll pick it up straight away."
        );
      }
      /* the page navigates from here if the hand-off worked */
    });
  }

  new MutationObserver(wire).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") wire();
  else document.addEventListener("DOMContentLoaded", wire);
  window.addEventListener("load", wire);
})();
